<template>
	<div>
		<buttonlist
				@help="help"
				@search="search"
				@reflash="reflash"
				@exps="exps"
				ref="SetBtn"
		></buttonlist>
		<el-table
				id="xpane-0"
				:data="dataSet"
				v-loading="loading"
				:highlight-current-row="true"
				show-overflow-tooltip="true"
				border
				stripe
				size="mini"
				:height="tableHeight"
				header-row-class-name="headerclass"
				style="width: 100%; margin-top:0px"
				ref="singleTable"
		>
			<el-table-column type="selection" v-if="false"></el-table-column>
			<el-table-column show-overflow-tooltip prop="vender_code" :label="$t('getapi[1287]')" sortable></el-table-column>
			<el-table-column show-overflow-tooltip prop="vender_name" :label="$t('getapi[1197]')" sortable></el-table-column>
			<el-table-column show-overflow-tooltip prop="actual_qty" :label="$t('getapi[1968]')" align="right" sortable>
				<template slot-scope="scope">
					{{scope.row.actual_qty | thousandth}}
				</template>
			</el-table-column>
			<el-table-column show-overflow-tooltip prop="disqualify_qty" :label="$t('getapi[1847]')" align="right" sortable>
				<template slot-scope="scope">
					{{scope.row.disqualify_qty | thousandth}}
				</template>
			</el-table-column>
			<el-table-column show-overflow-tooltip prop="pqc_qty" :label="$t('getapi[1969]')" align="right" sortable>
				<template slot-scope="scope">
					{{scope.row.pqc_qty | thousandth}}
				</template>
			</el-table-column>
			<el-table-column show-overflow-tooltip prop="dis_rate" label="DPPM" align="right" sortable></el-table-column>
			<el-table-column show-overflow-tooltip prop="dis_description" :label="$t('getapi[1970]')" sortable></el-table-column>
		</el-table>
		<el-row class="page">
			<!-- <el-col :span="18">
				<el-pagination
						style="margin-top: 1em"
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-sizes="[100, 200, 300, 400]"
						:page-size="100"
						:pager-count="5"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
				></el-pagination>
			</el-col> -->
			<el-col :span="24">
				<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
			</el-col>
		</el-row>
		<serce :isVisible="isVisible" queryData="PurQuanlityRateViewInfo" ref="ser" @getser="serclick"></serce>
	</div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    export default {
        name:'ppmview',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: 100, // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                scrollTop:0,
            };
        },
        watch:{
            dataSet: function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function() {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[966]"),this.$t("getapi[16]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                //只读权
                if (that.$limits.authority('plv2', 70, 1) == 1) {
                    //只读权
                    if (that.total > 0) {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    } else {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh');
					}
                }
                if (that.$limits.authority('plv2', 70, 1) == 2) {
                    if (that.$limits.authority('plv3', 70,1) == 0) {
                        if (that.total > 0) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh');
                        }
                    }
                    //操作权
                    if (that.$limits.authority('plv3', 70,1) == 1) {
                        //编辑级
                        if (that.total > 0) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh');
                        }
                    }
                    if (that.$limits.authority('plv3', 70, 1) == 2) {
                        //删除级
                        if (that.total > 0) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh');
                        }
                    }
                }
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.getView();
                this.authority();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
                this.authority();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'PurQuanlityRateViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let token = JSON.parse(that.userData).token;
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: 999999999,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/Pur/Statistics/GetPPMViewList', data, function(res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    }
                    that.loading = false;
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            // 导出
            exps() {
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac,
                    LangType: that.$processdata.getLang(),
                    fromname: that.$t('getapi[966]')
                };
                that.$http.urlpost('/Pur/Statistics/GetPPMViewToExecl', parm, function(res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
        }
    };
</script>

<style scoped lang="less">
	table {
		border-collapse: separate;
		border-spacing: 0px 5px;
		td {
			padding-left: 3px;
			white-space: pre;
		}
	}
</style>
